import { memo, useCallback, useEffect, VFC } from 'react'
import { CloseIcon } from 'src/assets/svgs'
import { truewhite, _menuicon, _messageroomborder } from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import { lineClamp3 } from 'src/styles/mixins'
import styled from 'styled-components'

type PreviewObject = {
  filename: string
  url?: string
}
export const AttachementsPreview: VFC<{
  files: File[]
  removeFile?: (index: number) => void
}> = memo(({ files, removeFile }) => {
  const previewObjects: PreviewObject[] = files.map((file) => {
    if (!file.type.startsWith('image')) return { filename: file.name }
    return {
      filename: file.name,
      url: window.URL.createObjectURL(file),
    }
  })
  const revokeAll = useCallback(
    () =>
      previewObjects.forEach(
        ({ url }) => url && window.URL.revokeObjectURL(url),
      ),
    [previewObjects],
  )
  useEffect(() => {
    return revokeAll
  }, [revokeAll])

  return (
    <AttachementsDiv>
      {previewObjects.map(({ filename, url }, idx) => (
        <Attachement key={url || `${filename}_${idx}`}>
          {url ? (
            <img src={url} alt="" />
          ) : (
            <Pdf>
              <h4>PDF</h4>
              <p>{filename}</p>
            </Pdf>
          )}
          {removeFile && (
            <button
              onClick={() => {
                removeFile(idx)
                revokeAll()
              }}
            >
              <CloseIcon />
            </button>
          )}
        </Attachement>
      ))}
    </AttachementsDiv>
  )
})

const Pdf = styled.div`
  border: 1px solid ${_messageroomborder};
  padding: 4px 8px;
  h4 {
    font-weight: ${fontWeightBold};
  }
  p {
    margin-top: 4px;
    width: 100%;
    word-break: break-all;
    ${lineClamp3};
  }
`

const AttachementsDiv = styled.div`
  display: flex;
  border-bottom: 1px solid ${_messageroomborder};
  padding-bottom: 8px;
  margin-bottom: 8px;
  > * {
    margin-right: 8px;
  }
  img,
  ${Pdf} {
    width: 92px;
    height: 64px;
    border-radius: 5px;
  }
  img {
    object-fit: cover;
  }
`
const Attachement = styled.div`
  position: relative;
  svg {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 16px;
    height: 16px;
    padding: 2px;
    fill: ${truewhite};
    background-color: ${_menuicon};
    border-radius: 50%;
  }
`
